import { render, staticRenderFns } from "./CarrierDhl.vue?vue&type=template&id=10dc7ae6&scoped=true&"
import script from "./CarrierDhl.vue?vue&type=script&lang=js&"
export * from "./CarrierDhl.vue?vue&type=script&lang=js&"
import style0 from "./CarrierDhl.vue?vue&type=style&index=0&id=10dc7ae6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dc7ae6",
  null
  
)

export default component.exports